import { render, staticRenderFns } from "./SidebarItemsGroup.vue?vue&type=template&id=f5fd4cf2&"
import script from "./SidebarItemsGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarItemsGroup.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemsGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports